import React, { useState, useEffect } from 'react';
import { useQuery } from '@apollo/client';
import DropDownPicker from 'react-native-dropdown-picker';
import { FindManySeasons } from '../../gql/season/query';

function SelectSeason({ selectedSeason, setSelectedSeason, style }) {
  const { data: seasonsData, loading: seasonsLoading } = useQuery(FindManySeasons);
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState(selectedSeason);
  const [items, setItems] = useState([]);

  useEffect(() => {
    if (seasonsData?.findManySeasons) {
      const seasonItems = seasonsData.findManySeasons.map((season) => ({
        label: season.name,
        value: Number(season.id),
      }));
      setItems(seasonItems);
      setValue(seasonItems[0].value);
    }
  }, [seasonsData]);

  useEffect(() => {
    setSelectedSeason(value);
  }, [value]);

  return seasonsLoading ? null : (
    <DropDownPicker
      dropDownDirection="BOTTOM"
      open={open}
      value={value}
      items={items}
      setOpen={setOpen}
      setValue={setValue}
      setItems={setItems}
      containerStyle={[{ width: 150 }, style]}
      placeholder="Saison"
      listMode="FLATLIST"
      zIndex={1000}
    />
  );
}

export default SelectSeason;
